import { TokenManager } from "../../common/utils/TokenManager";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

const api = axios.create({
    baseURL: BACKEND_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// requests interceptor to append authorization header
api.interceptors.request.use(
    (config) => {
        const token = TokenManager.getToken();
        if (token) {
            config.headers.Authorization = `JWT ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error),
);

// response interceptor to refresh token on receiving 401 status
api.interceptors.response.use(
    (response) => {
        // modify the response data
        // console.log("Response interceptor: ", response.data);
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        // If the error status is 401 and there is no originalRequest._retry flag,
        // it means the token has expired and we need to refresh it
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const refreshToken = TokenManager.getRefreshToken();
                const response = await axios.post(BACKEND_URL + "auth/jwt/refresh/", { refreshToken });
                const { token } = response.data;

                localStorage.setItem("token", token);

                // Retry the original request with the new token
                originalRequest.headers.Authorization = `JWT ${token}`;
                return axios(originalRequest);
            } catch (error) {
                // Handle refresh token error or redirect to login
                console.log("Refresh token error: ", error);
                TokenManager.clearToken();
            }
        }

        return Promise.reject(error);
    },
);

export default api;
